import { render, staticRenderFns } from "./AppVideoPlayer.vue?vue&type=template&id=44fcec54&scoped=true&"
import script from "./AppVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./AppVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AppVideoPlayer.vue?vue&type=style&index=0&id=44fcec54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcec54",
  null
  
)

export default component.exports